import "core-js/stable";
import "regenerator-runtime/runtime";
import ReactDOM, { hydrate, render } from 'react-dom';
import React from 'react';

import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import * as serviceWorker from './serviceWorker';
import store from './state-management/store/store-index';
import { Provider } from 'react-redux';
import { StylesProvider } from '@material-ui/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

// window.searchYoutube = searchYoutube;
window.onerror = function (message, url, lineNo, colNo, error) {

	console.log(arguments);

	var container = document.createElement('div');

	container.style.color = 'red';
	container.style.position = 'fixed';
	container.style.background = '#eee';
	container.style.padding = '2em';
	container.style.top = '1em';
	container.style.left = '1em';

	var msg = document.createElement('pre');
	msg.innerText = [
		'Message: ' + message,
		'URL: ' + url,
		'Line: ' + lineNo,
		'Column: ' + colNo,
		'Stack: ' + (error && error.stack)
	].join('\n');

	container.appendChild(msg);

	document.body.appendChild(container);
};

const THEME = createMuiTheme({
	typography: {
		"fontFamily": "\"Ultra\", \"Helvetica\", \"Arial\", sans-serif",
		//  "fontSize": 14,
		//  "fontWeightLight": 300,
		//  "fontWeightRegular": 400,
		//  "fontWeightMedium": 500
	}
});


const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
	hydrate(<BrowserRouter>
		<Provider store={store}>
			<MuiThemeProvider theme={THEME}>
				<StylesProvider injectFirst>
					<App />
				</StylesProvider>
			</MuiThemeProvider>
		</Provider>
	</BrowserRouter>, rootElement);
} else {
	render(<BrowserRouter>
		<Provider store={store}>
			<MuiThemeProvider theme={THEME}>
				<StylesProvider injectFirst>
					<App />
				</StylesProvider>
			</MuiThemeProvider>
		</Provider>
	</BrowserRouter>, rootElement);
}

// ReactDOM.render(
// 	<BrowserRouter>
// 		<Provider store={store}>
// 			<StylesProvider injectFirst>
// 				<App />
// 			</StylesProvider>
// 		</Provider>
// 	</BrowserRouter>, 
// 	rootElement
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// "scripts": {
//     "start": "react-scripts start",
//     "build": "set GENERATE_SOURCEMAP=false && react-scripts build",
//     "test": "react-scripts test",
//     "eject": "react-scripts eject",
//     "now-dev": "react-scripts start",
//     "now-build": "react-scripts build",
//     "postbuild": "react-snap"
//   },